import React from 'react';

import { Modal as AntdModal } from 'antd';
import { ChevronLeft, X } from 'lucide-react';

interface ModalProps {
  title: string;
  description?: string;
  open?: boolean;
  onClose: () => void;
  onBack?: () => void;
  children: React.ReactNode;
  width?: number | string;
  bodyClassName?: string;
  bodyStyle?: React.CSSProperties;
  titleCenter?: boolean;
  headerGradient?: string;
  headerActions?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  title,
  description,
  open = true,
  onClose,
  onBack,
  children,
  width = 896,
  bodyClassName = '',
  bodyStyle,
  titleCenter = false,
  headerGradient,
  headerActions,
}) => (
  <AntdModal
    open={open}
    onCancel={onClose}
    closable={false}
    title={null}
    footer={null}
    centered
    destroyOnHidden
    width={width}
    rootClassName="modal-no-padding modal-center-animation"
  >
    {/* Header */}
    {titleCenter ? (
      <div
        className="relative flex items-center justify-center px-6 py-4"
        style={headerGradient ? { background: headerGradient } : undefined}
      >
        {onBack ? (
          <button
            type="button"
            aria-label="返回上一级"
            onClick={onBack}
            className="absolute left-6 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-dark-text-secondary transition duration-base ease-base hover:text-dark-text"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
        ) : null}
        <h2 className="text-lg font-semibold text-dark-text">{title}</h2>
        <button
          type="button"
          aria-label="关闭弹窗"
          onClick={onClose}
          className="absolute right-6 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-dark-text-secondary transition duration-base ease-base hover:text-dark-text"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    ) : (
      <div
        className="flex items-start justify-between px-6 py-4"
        style={headerGradient ? { background: headerGradient } : undefined}
      >
        <div className="flex min-w-0 items-start gap-3">
          {onBack ? (
            <button
              type="button"
              aria-label="返回上一级"
              onClick={onBack}
              className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-dark-text-secondary transition duration-base ease-base hover:text-dark-text"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
          ) : null}
          <div className="min-w-0">
            <h2 className="text-lg font-semibold text-dark-text">{title}</h2>
            {description ? (
              <p className="mt-1 text-sm text-dark-text-secondary">{description}</p>
            ) : null}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          {headerActions}
          <button
            type="button"
            aria-label="关闭弹窗"
            onClick={onClose}
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-dark-text-secondary transition duration-base ease-base hover:text-dark-text"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    )}

    {/* Body */}
    <div className={`max-h-[80vh] overflow-y-auto px-6 py-4 ${bodyClassName}`} style={bodyStyle}>
      {children}
    </div>
  </AntdModal>
);

export default Modal;
